module.exports = __webpack_public_path__ + "img/rem1.4ccf544f.jpg";